<template>
    <a class="menu-link"
       :class="{'last-child-item': isLastChildItem}"
       ref="menuLink"
       :href="item.url"
       v-on:click="handleMenuItemInteraction($event, item, depth, preventDefault)"
       v-on:touchend="handleMenuItemInteraction($event, item ,depth, preventDefault)"
       v-on:mouseenter="handleMenuItemInteraction($event, item ,depth, preventDefault)"
       v-on:keydown="handleMenuItemInteraction($event, item ,depth, preventDefault)">
        <component v-if="displayIcon && getSvgSlug()" :is="renderSVG()"></component>
        <span class="link-text">{{ preText ? preText + " " : "" }}{{ item.title }}{{ postText ? " " + postText : "" }}</span>
        <span class="link-text--hover">{{ preText ? preText + " " : "" }}{{ item.title }}{{ postText ? " " + postText : "" }}</span>
        <span class="after"></span>
    </a>
</template>

<script>
// import useSvgSprite from "../../composables/use-svg-sprite";
import {h} from "vue";

export default {
    data() {
        return {};
    },
    props: {
        item:                {
            type:    Object,
            default: {}
        },
        depth:               {
            type:    Number,
            default: 1
        },
        index:               {
            type:    Number,
            default: 0
        },
        preventDefault:      {
            type:    Boolean,
            default: true
        },
        displayIcon:         {
            type:    Boolean,
            default: false
        },
        isFirstTopLevelItem: {
            type:    Boolean,
            default: false
        },
        isLastTopLevelItem:  {
            type:    Boolean,
            default: false
        },
        isLastChildItem:     {
            type:    Boolean,
            default: false
        },
        isRootMenuItem: {
            type: Boolean,
            default: false
        },
        preText:             {
            type:    String,
            default: ""
        },
        postText:            {
            type:    String,
            default: ""
        }
    },

    computed: {},

    mounted() {
        // console.log('MenuLink.vue mounted');

        // close the activeSubMenuParentMenuLink when any topLevelMenuLinks are brought into focus
        if (this.depth === 1) {
            this.$refs.menuLink.addEventListener('focus', (e) => {
                if (!this.$parent.mobileMenuActive) {
                    if (this.$parent.activeSubMenuParentMenuLink) {
                        // console.log('focus changed:  Closing active subMenu')
                        this.$parent.activeSubMenuParentMenuLink.parentNode.classList.remove('expanded');
                    }
                    if (this.$parent.activeMegaSubMenu) {
                        // console.log('focus changed:  Closing activeMegaSubMenu')
                        let activeMegaSubMenu = document.querySelector('.mega.sub-menu-wrapper.active');
                        if (activeMegaSubMenu) {
                            activeMegaSubMenu.classList.remove('active');
                        }
                    }
                }
            });
        }
    },
    methods: {
        getSvgSlug() {
            for (let i = 0; i < this.item.classes.length; i++) {
                if (this.item.classes[i].includes('svg')) {
                    return this.item.classes[i].replace('svg-', '');
                }
            }
            return "";
        },
        renderSVG() {
            if (this.getSvgSlug()) {
                const svgElement = document.getElementById(this.getSvgSlug());

                let attributes = {};
                for (let i = 0; i < svgElement.attributes.length; i++) {
                    let elementAttribute = svgElement.attributes[i];
                    if (elementAttribute.specified) {
                        attributes[elementAttribute.name] = elementAttribute.value;
                    }
                }

                return h(
                    'svg',
                    {
                        ...attributes,
                        innerHTML: svgElement.innerHTML
                    },
                );
            }
            return ""
        },
        setTopLevelMenuLinkActive(topLevelMenuLink) {
            this.$parent.activeMegaMenuParentLink = topLevelMenuLink;
            this.$parent.$refs.primaryNavigation.querySelector('.active').classList.remove('active');
            this.$parent.activeMegaMenuParentLink.focus();
            this.$parent.activeMegaMenuParentLink.parentNode.classList.add('active');
        },
        handleMenuItemInteraction(e, item, depth, preventDefault = true) {


            /**
             * Mobile Only
             */
            if (this.$parent.mobileMenuActive) {

                if (e.type === "click" || (e.type === "touchend")) {
                    // if the item has children, and it is not the root menu item (which has children, because it is a copy)
                    // checking if it is the root-menu-item, ensure that we do not prevent its functionality.
                    if (item.children.length > 0 && !this.isRootMenuItem) {
                        if(preventDefault) {
                            e.preventDefault();
                        }
                        e.target.parentNode.classList.add('expanded');
                        this.$parent.activeSubMenuParentMenuLink = e.target;
                        e.target.parentNode.querySelector('.nav-link-back .menu-link').focus();
                    }
                } else if (e.type === "mouseenter") {
                    e.target.focus()
                    // e.target
                } else if (e.type === "keydown") {

                    // When tabbing backwards,
                    // if the previous menu-item has a sub-menu,
                    // set focus() to the topLevelMenuItem instead of it's last submenu-item that would be the normal tab order.
                    if (e.key === 'Tab' && e.shiftKey) {
                        let prev = e.target.parentNode.previousSibling
                        if (prev && prev.classList && prev.classList.contains('more')) {
                            setTimeout(() => {
                                prev.querySelector('a').focus();
                            }, 20);
                        }
                    }

                    // if the user presses "Tab" on the last menu-link,
                    // close the mobile-menu and let the browser set the focus to the next focusable item.
                    if (item.isLastItem && e.key === 'Tab') {
                        this.$parent.closeMobileMenu();
                        return;
                    }

                    // if this is the last top-level item in the menu.
                    // if the user presses tab, close the menu and set focus to the next item outside the menu
                    if (this.isLastTopLevelItem) {
                        if (e.key === 'Tab' && !e.shiftKey) {
                            this.$parent.closeMobileMenu();
                            this.$parent.setFocusToNextItemOutsideMenu();
                            return;
                        }
                    }

                    if (this.isLastChildItem) {
                        // console.log('last child item')
                        if (e.key === 'Tab' && !e.shiftKey) {
                            let parentMenuItem = e.target.parentNode.parentNode.closest('.more');
                            parentMenuItem.classList.remove('expanded');
                            let nextMenuItem = parentMenuItem.nextElementSibling;

                            // if the parentMenuItem is itself the last child in a sub-menu,
                            // find the next parentMenuItem and set focus to it,
                            // if the parentMenuItem is the last child in the menu, close the menu and set focus to the next item outside the menu
                            while (!nextMenuItem) {
                                parentMenuItem = parentMenuItem.parentNode.parentNode.closest('.more');
                                parentMenuItem.classList.remove('expanded');
                                nextMenuItem = parentMenuItem.nextElementSibling;
                                if (!parentMenuItem) {
                                    this.$parent.closeMobileMenu();
                                    this.$parent.setFocusToNextItemOutsideMenu();
                                    return;
                                }
                            }

                            if (nextMenuItem) {
                                // console.log(parentMenuItem)
                                // console.log(nextMenuItem)
                                let nextMenuItemLink = nextMenuItem.querySelector('a');
                                this.$parent.activeSubMenuParentMenuLink = nextMenuItemLink;

                                setTimeout(() => {
                                    nextMenuItemLink.focus();
                                }, 20);
                                return;
                            }
                        }
                    }


                    if (e.target.parentNode.classList.contains('more')) {
                        // Skip to next menu-item if the user presses "Shift + Tab"
                        if (e.key === 'Tab' && !e.shiftKey) {
                            // console.log('skipping submenu')

                            let next = e.target.parentNode.nextSibling
                            // console.log(next)
                            setTimeout(() => {
                                next.querySelector('a').focus();
                            }, 20);
                        }
                            // Enter the submenu if the user presses "Enter"
                        // Set the .nav-link-back .menu-item to focus()
                        else if (e.key === 'Enter') {
                            // console.log('entering submenu')
                            if (preventDefault) {
                                e.preventDefault();
                            }
                            e.target.parentNode.classList.add('expanded');
                            e.target.parentNode.querySelector('.nav-link-back .menu-link').focus();
                            this.$parent.activeSubMenuParentMenuLink = e.target;
                        }
                    }
                }
            }

            /**
             * Desktop Only
             */
            else {
                /**
                 * Mega Menu
                 */
                if (this.$parent.isMegaMenu) {

                    if (e.type === "click" || (e.type === "touchend") || (e.type === "mouseenter")) {

                        // Display Mega-Menu Section
                        if (depth === 1) {
                            if (preventDefault) {
                                e.preventDefault();
                            }
                            if (e.target !== this.$parent.activeMegaMenuParentLink) {
                                this.setTopLevelMenuLinkActive(e.target);
                            }
                        }
                    } else if (e.type === "keydown") {

                        // If this is the last menu-item in the menu, and the user presses Tab
                        // close the menu and set focus to the next item outside the menu
                        if (item.isLastItem && e.key === 'Tab' && !e.shiftKey) {
                            // console.log('tabbing past last item in menu')
                            this.$parent.closeMegaMenu();
                            this.$parent.setFocusToNextItemOutsideMenu();
                            return;
                        }


                        // if this is the last top-level item in the menu, and the user presses Tab
                        // close the menu and set focus to the next item outside the menu
                        if (this.isFirstTopLevelItem) {
                            if (e.key === 'Tab' && e.shiftKey) {
                                e.preventDefault();
                                this.$parent.closeMegaMenu();
                                document.querySelector('.menu-toggle-wrapper.mega .menu-toggle').focus();
                                return;
                            }
                        }

                        // if this is the last top-level item in the menu, and the user presses Tab
                        // close the menu and set focus to the next item outside the menu
                        if (this.isLastTopLevelItem) {
                            if (e.key === 'Tab' && !e.shiftKey) {
                                this.$parent.closeMegaMenu();
                                this.$parent.setFocusToNextItemOutsideMenu();
                                return;
                            }
                        }


                        if (depth === 1) {

                            // When tabbing backwards,
                            // If the previous menu-item has a sub-menu,
                            // set focus() to the topLevelMenuItem instead of the submenu-item that would be the normal tab order.
                            if (e.key === 'Tab' && e.shiftKey) {
                                let prev = e.target.parentNode.previousSibling;
                                if (prev && prev.classList && prev.classList.contains('more')) {
                                    e.preventDefault();
                                    this.setTopLevelMenuLinkActive(prev.querySelector('a'));
                                }
                            }

                            if (e.target.parentNode.classList.contains('more')) {

                                // When tabbing forwards,
                                // Do not enter the submenu if the user presses "Tab",
                                // Instead, go to the next top-level menu-item
                                if (e.key === 'Tab' && !e.shiftKey) {
                                    // console.log(this.isLastChildItem)
                                    if (!this.isLastChildItem) {
                                        let next = e.target.parentNode.nextSibling
                                        if (next) {
                                            e.preventDefault();
                                            this.setTopLevelMenuLinkActive(next.querySelector('a'));
                                        }
                                    }

                                }
                                    // When pressing "Enter"
                                // Enter the submenu and set focus to the root-menu-item
                                else if (e.key === 'Enter') {
                                    e.preventDefault();

                                    // find the root menu item and make it visible
                                    let rootMenuItem = e.target.parentNode.querySelector('.root-menu-item');
                                    rootMenuItem.querySelector('.menu-link').focus();
                                }

                            }
                        } else if (depth === 2) {

                            if (e.target.closest('.sub-menu-wrapper')) {

                                let subMenuItems = e.target.closest('.sub-menu-wrapper').querySelectorAll('a');
                                let lastSubMenuItem = subMenuItems[subMenuItems.length - 1];
                                lastSubMenuItem.classList.add('last-item');

                                // jump to the next top-level menu-item when tabbing past the last item in a mega-sub-menu
                                if (e.key === 'Tab' && !e.shiftKey) {

                                    if (e.target.classList.contains('last-item')) {
                                        e.preventDefault();
                                        let nextTopLevelMenuItem = this.$parent.activeMegaMenuParentLink.parentNode.nextSibling;
                                        if (nextTopLevelMenuItem) {
                                            let nextTopLevelMenuItemLink = nextTopLevelMenuItem.querySelector('a');
                                            this.setTopLevelMenuLinkActive(nextTopLevelMenuItemLink);
                                        }

                                    }
                                }

                            }
                        }
                    }
                }
                /**
                 * Inline
                 */
                else {

                    if (e.type === "click" || (e.type === "touchend") || (e.type === "mouseenter")) {
                        // Display mega-sub-menu
                        if (depth === 1) {
                            // close and mega-sub-menus open on desktop when transitioning to mobile.
                            // let activeMegaSubMenu = document.querySelector('.mega.sub-menu-wrapper.active');
                            if (this.$parent.activeMegaSubMenu) {
                                this.$parent.activeMegaSubMenu.classList.remove('active');
                            }

                            if (e.target.parentNode.classList.contains('mega-sub-menu')) {
                                // find the root menu item and make it visible
                                this.$parent.activeMegaSubMenu = document.getElementById('top-level-sub-menu-' + (this.index + 1));
                                this.$parent.activeSubMenuParentMenuLink = e.target;
                                setTimeout(() => {
                                    this.$parent.activeMegaSubMenu.classList.add('active');
                                }, 20);
                            }
                        }

                        if (e.type === "touchend") {
                            if (depth === 1) {
                                if (preventDefault) {
                                    e.preventDefault();
                                }
                                if (e.target.parentNode.classList.contains('expanded')) {
                                    this.$parent.activeSubMenuParentMenuLink.parentNode.classList.remove('expanded');
                                    this.$parent.activeSubMenuParentMenuLink = null;
                                }

                                if (e.target.parentNode.classList.contains('more')) {
                                    // find the root menu item and make it visible
                                    let rootMenuItem = e.target.parentNode.querySelector('.root-menu-item');
                                    if (rootMenuItem) {
                                        rootMenuItem.style.display = 'list-item';
                                    }
                                }

                                if (e.target.parentNode.classList.contains('mega-sub-menu')) {
                                    let rootMenuItem = this.$parent.activeMegaSubMenu.querySelector('.root-menu-item');
                                    rootMenuItem.style.display = 'list-item';
                                    rootMenuItem.querySelector('.menu-link').focus();
                                }
                            }
                        }

                    } else if (e.type === "keydown") {

                        // When tabbing backwards,
                        // if the previous menu-item has a sub-menu,
                        // set focus() to the topLevelMenuItem instead of it's last submenu-item that would be the normal tab order.
                        if (e.key === 'Tab' && e.shiftKey) {
                            let prev = e.target.parentNode.previousSibling
                            if (prev && prev.classList && prev.classList.contains('more')) {
                                setTimeout(() => {
                                    prev.querySelector('a').focus();
                                }, 20);
                            }
                        }

                        // If this is the last menu-item in the menu, and the user presses Tab
                        // close the menu and set focus to the next item outside the menu
                        if (item.isLastItem && e.key === 'Tab' && !e.shiftKey) {
                            // console.log('tabbing past last item in menu')
                            if (this.$parent.$refs.primaryNavigation.querySelector('.expanded')) {
                                this.$parent.$refs.primaryNavigation.querySelector('.expanded').classList.remove('expanded');
                            }

                            this.$parent.setFocusToNextItemOutsideMenu();
                            return;
                        }

                        // if this is the last top-level item in the menu, and the user presses Tab
                        // close the menu and set focus to the next item outside the menu
                        if (this.isLastTopLevelItem) {
                            if (e.key === 'Tab' && !e.shiftKey) {
                                this.$parent.setFocusToNextItemOutsideMenu();
                                return;
                            }
                        }


                        if (depth === 1) {

                            // When tabbing backwards,
                            // If the previous menu-item has a sub-menu,
                            // set focus() to the topLevelMenuItem instead of the submenu-item that would be the normal tab order.
                            if (e.key === 'Tab' && e.shiftKey) {
                                let prev = e.target.parentNode.previousSibling;
                                if (prev && prev.classList && prev.classList.contains('more')) {
                                    setTimeout(() => {
                                        prev.querySelector('a').focus();
                                    }, 20);

                                }
                            }

                            // if the menu-item has a sub-menu
                            if (e.target.parentNode.classList.contains('more')) {

                                // if the user is tabbing forward, do not enter the sub-menu,
                                // instead skip to the next menu-item
                                if (e.key === 'Tab' && !e.shiftKey) {
                                    // console.log(this.isLastChildItem)
                                    if (!this.isLastChildItem) {
                                        let next = e.target.parentNode.nextSibling
                                        if (next) {
                                            setTimeout(() => {
                                                next.querySelector('a').focus();
                                            }, 20);
                                        }
                                    }

                                }
                                    // if the user presses "Enter",
                                // Open the SubMenu
                                else if (e.key === 'Enter') {
                                    this.$parent.activeSubMenuParentMenuLink = e.target;

                                    if (preventDefault) {
                                        e.preventDefault();
                                    }

                                    if (e.target.parentNode.classList.contains('mega-sub-menu')) {

                                        // find the root menu item and make it visible
                                        this.$parent.activeMegaSubMenu = document.getElementById('top-level-sub-menu-' + (this.index + 1));
                                        console.log(this.$parent.activeMegaSubMenu)
                                        setTimeout(() => {
                                            this.$parent.activeMegaSubMenu.classList.add('active');
                                        }, 20);

                                        // find the root menu item and set focus() to it
                                        let rootMenuItem = this.$parent.activeMegaSubMenu.querySelector('.root-menu-item');
                                        rootMenuItem.style.display = 'list-item';
                                        setTimeout(() => {
                                            rootMenuItem.querySelector('.menu-link').focus();
                                        }, 20);

                                    } else {

                                        // find the root menu item and make it visible
                                        let rootMenuItem = e.target.parentNode.querySelector('.root-menu-item');
                                        rootMenuItem.style.display = 'list-item';
                                        setTimeout(() => {
                                            e.target.parentNode.classList.add('expanded');
                                            rootMenuItem.querySelector('.menu-link').focus();
                                        }, 20);
                                    }
                                }

                            }
                        } else {

                            if (e.target.closest('.mega.sub-menu-wrapper')) {
                                let subMenuItems = e.target.closest('.mega.sub-menu-wrapper').querySelectorAll('a');
                                let lastSubMenuItem = subMenuItems[subMenuItems.length - 1];
                                lastSubMenuItem.classList.add('last-item');


                                // jump to the next top-level menu-item when tabbing past the last item in a mega-sub-menu
                                if (e.key === 'Tab' && !e.shiftKey) {

                                    if (e.target.classList.contains('last-item')) {
                                        this.$parent.activeSubMenuParentMenuLink.focus();
                                    }
                                }

                                // jump to the parent top-level menu-item when back-tabbing from the root-menu-item in a mega-sub-menu
                                if (e.key === 'Tab' && e.shiftKey) {
                                    if (e.target.parentNode.classList.contains('root-menu-item')) {
                                        console.log('back-tabbing from root-menu-item in mega-sub-menu')

                                        setTimeout(() => {
                                            this.$parent.activeSubMenuParentMenuLink.focus();
                                        }, 20);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

</script>